import { useState } from 'react';
import { api, type AskResponse } from '../lib/api';
import { AnswerMarkdown, CitationCards, WikiBadges } from '../lib/askRender';
import { ErrorBox } from './Watchlist';

export default function AskPage() {
  const [symbol, setSymbol] = useState('005930');
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<AskResponse | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!question.trim()) return;
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const r = await api.ask(question.trim(), symbol || undefined);
      setResult(r);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <section>
      <h1 className="text-2xl font-semibold tracking-tight">Ask</h1>
      <p className="mt-1 text-sm text-slate-500">Grounded RAG · 인용 없이는 답하지 않음</p>

      <form onSubmit={submit} className="mt-5 space-y-3 rounded-lg border border-slate-200 bg-white p-5">
        <label className="block">
          <span className="text-xs font-medium text-slate-700">종목 (optional)</span>
          <input
            type="text"
            value={symbol}
            onChange={(e) => setSymbol(e.target.value)}
            placeholder="005930"
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-1.5 font-mono text-sm"
          />
        </label>
        <label className="block">
          <span className="text-xs font-medium text-slate-700">질문</span>
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            rows={3}
            placeholder="HBM3E 양산 일정과 매출 영향은?"
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2 text-sm"
          />
        </label>
        <button
          type="submit"
          disabled={loading || !question.trim()}
          className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white disabled:bg-slate-400"
        >
          {loading ? '검색·생성 중…' : '질문하기'}
        </button>
      </form>

      {error && <div className="mt-4"><ErrorBox msg={error} /></div>}

      {result && (
        <div className="mt-6 space-y-4">
          <div className="rounded-lg border border-slate-200 bg-white p-5">
            <div className="flex items-center gap-3 text-xs text-slate-500">
              <span>비용 ${result.cost_usd.toFixed(4)}</span>
              <span>latency {result.latency_ms}ms</span>
              {result.uncertain && (
                <span className="rounded bg-amber-100 px-2 py-0.5 font-medium text-amber-800">
                  uncertain
                </span>
              )}
            </div>
            <AnswerMarkdown answer={result.answer} chunks={result.retrieval.chunks_used} />
            <WikiBadges sections={result.wiki_context_used} />
          </div>

          <CitationCards chunks={result.retrieval.chunks_used} wikiUsed={result.wiki_context_used} />
        </div>
      )}
    </section>
  );
}
